var exports = {
  "kL": "PushSettings.module__container___WnhSQk",
  "I6": "PushSettings.module__selectOnlyContainer___WnhSQk",
  "Qq": "PushSettings.module__text___WnhSQk",
  "DD": "PushSettings.module__title___WnhSQk",
  "h_": "PushSettings.module__description___WnhSQk",
  "GL": "PushSettings.module__comboboxWrap___WnhSQk",
  "EA": "PushSettings.module__combobox___WnhSQk",
};

module.exports = exports;
